enum ResolveSpacingByDirection {
  'ANTERIOR' = 'ANTERIOR',
  'POSTERIOR' = 'POSTERIOR',
  'BOTH' = 'BOTH',
}

export { ResolveSpacingByDirection }
